module.exports = __webpack_public_path__ + "img/DSIIII.fdde3447.png";